import request from '@/service/lib/request'

/**
 * 依科曼鼠害 - 获取设备列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getDevices(params) {
  return request({
    url: `/api/v1/rodents/devices`,
    method: 'get',
    params
  })
}

/**
 * 依科曼鼠害 - 获取鼠害数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} params -- companyId 组织 ID
 * @param {Object} params -- startTime 起始时间 2021-01-16 10:27:21
 * @param {Object} params -- endTime 结束时间 2022-05-16 10:27:21
 * @param {Object} params -- deviceId 设备 ID
 */
export function getSdata(params) {
  return request({
    url: `/api/v1/rodents/sdata`,
    method: 'get',
    params
  })
}

/**
 * 依科曼鼠害 - 获取鼠害视频
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} params -- companyId 组织 ID
 * @param {Object} params -- startTime 起始时间 2021-01-16 10:27:21
 * @param {Object} params -- endTime 结束时间 2022-05-16 10:27:21
 * @param {Object} params -- deviceId 设备 ID
 */
export function getVideo(params) {
  return request({
    url: `/api/v1/rodents/video`,
    method: 'get',
    params
  })
}

/**
 * 依科曼鼠害 - 获取鼠害视频播放地址
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} params -- companyId 组织 ID
 * @param {Object} params -- yunId
 */
export function getSource(params) {
  return request({
    url: `/api/v1/rodents/source`,
    method: 'get',
    params
  })
}
